<template>
  <div class="hero-body is-block">
    <div class="container">
      <div class="columns">

        <!-- Nav menu -->
        <div class="column is-3">
          <aside class="menu">

            <template v-for="section in sections">
              <p class="menu-label" :key="section.title">
                {{ section.title }}
              </p>
              <ul class="menu-list" :key="section.title">
                <li v-for="child in section.children"
                    :key="child.title">
                  <a :class="{ 'is-active': child.isActive }"
                     @click.prevent="setActiveChild(child)">{{ child.title }}</a>
                </li>                    
              </ul>     
            </template>     

          </aside>          
        </div>

        <!-- Main content -->
        <div class="column is-9">

          <section class="hero is-info welcome is-small">
            <div class="hero-body">
              <div class="container">
                <h1 class="title">
                  {{ title }}
                </h1>
              </div>
            </div>
          </section>

          <section style="margin-top: 1.5rem">
            <keep-alive>
              <component :is="currentComp"></component>
            </keep-alive>
          </section>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import About from './about/About.vue'
import Attributions from './about/Attributions.vue'
import Feedback from './about/Feedback.vue'
import GetUpdates from './about/GetUpdates.vue'
import PrivacyPolicy from './about/PrivacyPolicy.vue'
import TermsOfService from './about/TermsOfService.vue'

export default {
  name: "about",
  components: {
    About,
    Feedback,   
    GetUpdates,

    Attributions,

    TermsOfService,
    PrivacyPolicy,
  },
  data: function() {
    return {
      sections: [
        { title: 'General', 
          children: [
            { title: 'About', isActive: true, comp: 'About' },
            { title: 'Give Feedback', isActive: false, comp: 'Feedback' },
            { title: 'Get updates', isActive: false, comp: 'GetUpdates' },
        ] },
        { title: 'Built With',
          children: [
            { title: 'Attributions', isActive: false, comp: 'Attributions' },
        ] },
        { title: 'Legalese',
          children: [
            { title: 'Terms of Service', isActive: false, comp: 'TermsOfService' },
            { title: 'Privacy Policy', isActive: false, comp: 'PrivacyPolicy' },
        ] },
      ],
      title: '',
      currentComp: ''
    };
  },  
  methods: {
    setActiveChild (child) {
      this.sections.forEach(section => {
        section.children.forEach(sectionChild => {
          sectionChild.title === child.title ? sectionChild.isActive = true : sectionChild.isActive = false
        });
      });
      this.title = child.title;
      this.currentComp = child.comp;
      this.$appInsights.trackPageView(`/about/${encodeURIComponent(child.title)}`);
      this.$ga.page({ page: `/about/${encodeURIComponent(child.title)}`, 
                      title: `About > ${child.title}` });
    }
  },
  mounted () {
    this.setActiveChild( this.sections[0].children[0] )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue